<template>
  <div class="content-wrapper">
    <section class="project-form">
      <ProjectEditForm/>
    </section>
  </div>
</template>

<script>
import ProjectEditForm from '@/components/project/ProjectEditForm.vue'

export default {
  name: 'ProjectEdit',
  components: {
    ProjectEditForm
  }
}
</script>
